export const siteContent = {
  navbar: {
    logo: {
      icon: "",
      text: "Paalana",
    },
    links: [
      { label: "Home", path: "/" },
      { label: "About Us", path: "/about" },
      { label: "Our Work", path: "/work" },
      { label: "Contact Us", path: "/contact" },
    ],
  },
  landing: {
    hero: {
      heading: "Empowering safer pregnancies through simple, trusted care—where access matters most.",
      description: "Paalana leverages AI-enabled, accessible technology to deliver culturally-grounded, evidence-based maternal health education to women in remote and underserved communities.",
      ctaButtons: [
        { label: "Explore More →", variant: "secondary" },
        { label: "Get Started →", variant: "primary" },
      ],
      backgroundImage: "",
    },
    whyChoose: {
      heading: "Why Choose Paalana",
      description: "AI-supported, culturally relevant maternal health education for underserved communities.",
      features: [
        {
          icon: "",
          title: "AI-Supported Chatbot",
          description: "Get instant support via an AI-supported chatbot on your mobile app anytime.",
        },
        {
          icon: "",
          title: "Pregnancy Journey",
          description: "Receive guidance tailored to your stage of pregnancy and individual care needs.",
        },
        {
          icon: "",
          title: "Multi-Language Support",
          description: "Communicate in English, Hindi, Gujarati, and many more local languages.",
        },
      ],
    },
    platformServices: {
      heading: "Our Platform Services",
      description: "Comprehensive support throughout your pregnancy journey.",
      services: [
        {
          icon: "",
          title: "Evidence-based Pregnancy Patient Education",
          description: "Access clear, medically reviewed pregnancy education designed for informed decision-making.",
        },
        {
          icon: "",
          title: "Local Resource Information",
          description: "Find nearby maternal health resources, services, and support options relevant to your community.",
        },
        {
          icon: "",
          title: "Escalation of Care",
          description: "Identify warning signs early and get guided next steps for timely clinical escalation.",
        },
      ],
    },
    howItWorks: {
      heading: "How Paalana Works",
      description: "Simple, secure, and accessible maternal care in three easy steps.",
      steps: [
        {
          number: 1,
          title: "Register on the Platform",
          description: "Get onboarded with support from providers and begin your pregnancy care journey.",
        },
        {
          number: 2,
          title: "Connect via Your Preferred Channel",
          description: "Access our AI chatbot by downloading our mobile app.",
        },
        {
          number: 3,
          title: "Get Personalized Support",
          description: "Receive health tips, vaccination reminders, and timely answers to your pregnancy questions.",
        },
      ],
    },
    cta: {
      heading: "Ready to Start Your Journey",
      description: "Join expecting mothers who trust NurturaX for their maternal care needs.",
    },
  },
  about: {
    heading: "",
    description: "",
  },
  features: {
    heading: "",
    description: "",
    items: [],
  },
  contact: {
    heading: "",
    description: "",
  },
  footer: {
    tagline: "Empowering expecting mothers with AI-supported care throughout their pregnancy journey in India.",
    socialLinks: [
      { platform: "X", url: "" },
      { platform: "YouTube", url: "" },
      { platform: "LinkedIn", url: "" },
      { platform: "Instagram", url: "" },
    ],
    links: {
      about: [
        { label: "About Us", path: "/about" },
        { label: "Our Work", path: "/work" },
      ],
      contact: [
        { label: "Contact Us", path: "/contact" },
      ],
    },
    contactInfo: {
      email: "nurturax@gmail.com",
    },
    legal: {
      copyright: "@2026 Paalana. All Right Reserved",
      links: [
        { label: "Privacy Policy", path: "/privacy" },
        { label: "Terms of Conditions", path: "/terms" },
      ],
    },
  },
};
